import React, { useState, useEffect } from 'react';
import { useAuthRouting } from '../contexts/AuthRouteContext';
import { useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';

export default function ChangePasswordPage() {
  const { requireAuth } = useAuthRouting();
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    requireAuth(() => {}, () => navigate('/login'));
  }, [requireAuth, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    setError('');

    // Replace with real API call
    // console.log('Changing password for user:', user.username);
    console.log('Old password:', currentPassword);
    console.log('New password:', newPassword);

    setSuccess(true);
    setTimeout(() => navigate('/profile'), 2000); // or any other destination
  };

  if (success) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>Password updated successfully</h2>
        <p>Redirecting...</p>
      </div>
    );
  }

  return (
    <AuthForm
      title="Change Your Password"
      image="/login.jpg"
      fields={[
        {
          name: 'currentPassword',
          label: 'Current Password',
          type: 'password',
          value: currentPassword,
          onChange: (e) => setCurrentPassword(e.target.value),
        },
        {
          name: 'newPassword',
          label: 'New Password',
          type: 'password',
          value: newPassword,
          onChange: (e) => setNewPassword(e.target.value),
        },
        {
          name: 'confirmPassword',
          label: 'Confirm New Password',
          type: 'password',
          value: confirmPassword,
          onChange: (e) => setConfirmPassword(e.target.value),
        },
      ]}
      onSubmit={handleSubmit}
      submitLabel="Update Password"
      showSocialIcons={false}
      footerLinks={[
        { href: '/profile', label: 'Back to profile' },
      ]}
    >
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
    </AuthForm>
  );
}
